// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3_F8R","type":"styles_type__2TxAP","choices":"styles_choices__1t-4q"};